import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export const FaqList = ({ faqs, tid }) => (
  <Accordion type="single" collapsible data-testid={tid} className="rounded-[24px] border border-line bg-white px-6">
    {faqs.map((f, i) => (
      <AccordionItem key={f.qEn + i} value={`f${i}`} className="border-line last:border-0">
        <AccordionTrigger data-testid={`${tid}-q-${i}`} className="py-5 text-left text-[17px] font-semibold text-ink hover:no-underline">
          <span>{f.qHi}<span className="font-en mt-0.5 block text-xs font-normal text-muted2">{f.qEn}</span></span>
        </AccordionTrigger>
        <AccordionContent className="pb-5 text-[15px] leading-relaxed text-ink/80">
          {f.aHi}<span className="font-en mt-2 block text-sm text-muted2">{f.aEn}</span>
        </AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);
